import React from 'react';

export const ASSISTIVE_TEXT_STATES = {
  ITEM_FOCUSED: 0,
  ITEM_ACTIVE: 1,
  ITEM_INACTIVE: 2,
  MATCH_SELECTED: 3,
  MATCH_REMOVED: 4,
};

export const AssistiveText = ({
  assistiveStatus,
  questionId,
  matchingResult,
}) => {
  let assistiveText = '';
  switch (assistiveStatus?.state) {
    case ASSISTIVE_TEXT_STATES.ITEM_FOCUSED:
      assistiveText = t(
        'learning.lessons.assistive_text.matching.item_focused',
        {
          item: assistiveStatus?.item,
          position: assistiveStatus?.position,
          total: assistiveStatus?.total,
        },
      );
      break;
    case ASSISTIVE_TEXT_STATES.ITEM_ACTIVE:
      assistiveText = t(
        'learning.lessons.assistive_text.matching.item_active',
        {
          item: assistiveStatus?.item,
        },
      );
      break;
    case ASSISTIVE_TEXT_STATES.ITEM_INACTIVE:
      assistiveText = t(
        'learning.lessons.assistive_text.matching.item_inactive',
      );
      break;
    case ASSISTIVE_TEXT_STATES.MATCH_SELECTED:
      assistiveText = t(
        'learning.lessons.assistive_text.matching.match_selected',
        {
          item: matchingResult.data.choices[assistiveStatus?.activeItem].item,
          match: assistiveStatus?.match,
        },
      );
      break;
    case ASSISTIVE_TEXT_STATES.MATCH_REMOVED:
      assistiveText = t(
        'learning.lessons.assistive_text.matching.match_removed',
        {
          item: assistiveStatus?.item,
        },
      );
      break;
    default:
      break;
  }
  return (
    <>
      <span
        role="region"
        id={`matchingInfo-${questionId}`}
        aria-live="assertive"
        className="sr-only"
      >
        <span>{assistiveText}</span>
      </span>
    </>
  );
};
